let KEY = '';
export default function getKey(){
   return KEY; 
}
export function setKey(key){
    KEY = key;
}